import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blank-redirect',
  templateUrl: './blank-redirect.component.html',
  styleUrls: ['./blank-redirect.component.css']
})
export class BlankRedirectComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
